import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Divider, Rating } from "@gemini/ui";
import { Box } from "@gemini/core";
import { PartnerBadges } from "@/components/contacting/ProviderSection/PartnerBadges";
import { InteractionEnum, } from "@/types";
import { useCustomerAction } from "@/hooks";
export const RatingsAndBadges = ({ testId, rating, badges, }) => {
    const { customerActionLeadInteraction } = useCustomerAction();
    const onClickRating = async () => {
        if (rating) {
            await customerActionLeadInteraction(InteractionEnum.CLICK, "valuation");
            window.open(rating.link, "_blank");
        }
    };
    if (!rating && !badges)
        return null;
    return (_jsxs(_Fragment, { children: [_jsx(Divider, { marginVertical: "spacing.24", "aria-hidden": "true" }), !!rating && (_jsx(Box, { as: "button", borderStyle: "hidden", padding: "spacing.none", display: "inline-flex", cursor: "pointer", onClick: onClickRating, testId: `${testId}.Rating.link`, children: _jsx(Rating, { size: "24", testId: `${testId}.Rating`, rating: rating.rating, reviews: rating.reviews }) })), badges && _jsx(PartnerBadges, { badges: badges })] }));
};
